<template>
  <div class="content-body">
    <div class="left-box">
      <div class="account-box background">
        <div class="left-header">
          <i class="el-icon-s-custom"></i>
        </div>
        <div class="company-name" v-text="data.user_name"></div>
      </div>
      <div class="expeded-box background">
        <div class="expeded-title">
          <div class="title">信息流推广</div>
          <div class="btn"><el-button type="primary" plain size="mini" @click="jumpPlan">新建广告</el-button></div>
        </div>
        <div class="expeded-content">
          <div class="one-content">
            <div class="c-title">余额</div>
            <div class="c-price" v-text="data.company_balance + '元'"></div>
          </div>
          <div class="one-content">
            <div class="c-title">预计可消费</div>
            <div class="c-price" v-text="data.howDays + '天'"></div>
          </div>
          <div class="one-content">
            <div class="c-title">今日消耗</div>
            <div class="c-price" v-text="data.today_pay + '元'"></div>
          </div>
          <div class="one-content">
            <div class="c-title">日预算</div>
            <div class="c-price">{{ showBudgetTitle(data.company_budget) }} <span @click="showBudget" style="cursor: pointer;"><i class="el-icon-edit"></i></span></div>
          </div>
        </div>
      </div>
      <div class="expeded-box background">
        <div class="expeded-title">
          <div class="title">公告</div>
        </div>
        <div class="expeded-content no-message">
          暂无公告消息
          <!-- <img src="../../assets/images/no-message.png" alt="message-no"> -->
        </div>
      </div>
    </div>

    <div class="right-box background">
      <div class="right-title">
        <div class="title">广告统计</div>
      </div>
      <div class="item-content">
        <div class="one-item">
          <div class="top" v-text="data.handle_adv"></div>
          <div class="bottom">审核中创意</div>
          <div class="icon"><i class="fa fa-clock-o" aria-hidden="true"></i></div>
        </div>
        <div class="one-item">
          <div class="top" v-text="data.action_adv"></div>
          <div class="bottom">投放中创意</div>
          <div class="icon"><i class="fa fa-ban" aria-hidden="true"></i></div>
        </div>
        <div class="one-item" style="margin-right: 0px;">
          <div class="top" v-text="data.fre_adv"></div>
          <div class="bottom">暂停创意</div>
          <div class="icon"><i class="fa fa-pause-circle-o" aria-hidden="true"></i></div>
        </div>
      </div>
      <div class="right-title">
        <div class="title">数据走势</div>
        <div>
          <el-date-picker v-model="time" type="daterange" align="right" :value-format="'yyyy-MM-dd'" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getLine" size="mini"></el-date-picker>
        </div>
      </div>
      <div class="echart" style="height: 550px;">
        <div id="echarts-records" :style="{width: 'calc(100% - 48px)', height: '500px', padding: '16px 24px', marginTop: '20px', background: '#fff'}"></div>
      </div>
      <div class="right-title">
        <div class="title">广告计划<span>当日数据预览</span></div>
        <div class="right-border">当天消耗的Top10</div>
      </div>
      <div class="table" style="margin-top: 20px;">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="today" label="日期" width="180"></el-table-column>
          <el-table-column prop="adv_title" label="广告单元"></el-table-column>
          <el-table-column prop="pay_money" label="花费"></el-table-column>
          <el-table-column prop="read_num" label="曝光量"></el-table-column>
          <el-table-column prop="qcbgcb" label="千次曝光成本"></el-table-column>
          <el-table-column prop="dchdcb" label="单次互动成本"></el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="修改账户预算" :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" label-width="80px" label-position="left">
        <el-form-item label="预算方式">
          <el-radio-group v-model="checked">
            <el-radio-button :label="1">不限预算</el-radio-button>
            <el-radio-button :label="0">指定预算</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指定预算" v-show="checked !== 1">
          <el-input v-model="input" placeholder="预算设置0元即暂停"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import echarts from 'echarts';
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      time: [],
      curentComponents: 'PlanView',
      data: [],
      dialogVisible: false,
      input: '',
      checked: 0,
      user_info: [],
      dateType: '1',
      count: [],
      tableData: []
    };
  },
  mounted() {
    // this.user_info = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info')) : [];
    this.$http.post('/trader/index/getIndexInfo').then(res => {
      if (res.code === 200) {
        this.data = res.data;
        this.checked = parseFloat(res.data.company_budget) >= 99999999 ? 1 : 0;
        this.input = parseFloat(res.data.company_budget);
        this.tableData = res.data.adv_lists;
        // this.$function.hiddenLoading();
        this.getLine();
      }
    });
  },
  methods: {
    getLine() {
      this.$http.post('/trader/data/getIndexCount', {
        time: this.time.join(',')
      }).then(res => {
        if (res.code === 200) {
          this.$function.hiddenLoading();
          // this.pay_money = res.data.pay_money;
          // this.look_num = res.data.look_num;
          // this.read_num = res.data.read_num;

          // this.count = res.count;
          // 填充数据表格
          const echartsRecords = echarts.init(document.getElementById('echarts-records'), 'walden');

          const option = {
            title: {
              text: '数据趋势'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },
            legend: {
              data: ['曝光', '点击', '支付']
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              boundaryGap: false,
              data: res.chat.name
            }],
            yAxis: [{
              type: 'value'
            }],
            series: [
              {
                name: '支付',
                type: 'line',
                stack: '总量',
                areaStyle: {
                  color: '#C4E7FF'
                },
                data: res.chat.pay
              },
              {
                name: '点击',
                type: 'line',
                stack: '总量',
                areaStyle: {},
                data: res.chat.cpc
              },
              {
                name: '曝光',
                type: 'line',
                stack: '总量',
                label: {
                  normal: {
                    show: true,
                    position: 'top'
                  }
                },
                areaStyle: {},
                data: res.chat.exposure
              }
            ]
          };
          echartsRecords.setOption(option);
        }
      });
    },
    sure() {
      this.$http.post('/trader/index/updateBudget', {
        budget: this.input
      }).then(res => {
        if (res.code === 200) {
          this.data.company_budget = this.input;
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.msg);
        }
        this.dialogVisible = false;
      });
    },
    showBudget() {
      this.checked = parseInt(this.input) === 99999999 ? 1 : 0;
      this.dialogVisible = true;
    },
    showBudgetTitle(val) {
      return parseInt(val) >= 99999999 ? '不限' : val;
    },
    jumpPage(url) {
      window.open(url);
    },
    jumpPlan() {
      this.$emit('jump_plan');
    },
    getForm(time) {
      return this.$function.formatDate(time, 'MM-dd');
    }
  },
  watch: {
    checked(newVal) {
      this.input = parseInt(newVal) ? 99999999 : 0;
    }
  }
};
</script>
<style lang="less" scoped="">
  .content-body {
    display: flex;
  }
  .background {
    background: #fff;
    border: 1px solid #f6f5f5;
    box-shadow: 0 6px 19px 0 rgba(0, 0, 0, .05);
    border-radius: 4px;
  }
  .left-box {
    width: 278px;
    padding-right: 23px;
    .account-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 276px;
      height: 118px;
      margin-bottom: 24px;
      .left-header {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        font-size: 24px;
        background: #00A1D6;
        border-radius: 50%;
        i {
          color: #fff;
        }
      }
      .company-name {
        margin-left: 16px;
        display: inline-block;
        width: 154px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #333333;
        font-size: 16px;
        color: #666;
        letter-spacing: 0;
      }
    }
    .expeded-box {
      width: 276px;
      margin-bottom: 24px;
      .expeded-title {
        height: 56px;
        display: flex;
        justify-content: space-between;
        line-height: 56px;
        border-bottom: 1px solid #f3f3f3;
        .title {
          font-size: 16px;
          color: #666;
          letter-spacing: 0;
          padding-left: 22px;
        }
        .btn {
          padding-right: 22px;
        }
      }
      .expeded-content {
        height: 167px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .one-content {
          text-align: center;
          height: 83.5px;
          width: 138px;
          font-size: 12px;
          color: #999;
          .c-title {
            margin-top: 25px;
          }
          .c-price {
            margin-top: 3px;
            font-size: 14px;
            font-weight: 500;
            color: #666;
          }
        }
      }
      .no-message {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ccc;
        img {
          width: 90px;
        }
      }
    }
  }

  .right-box {
    width: calc(100% - 341px);
    padding: 10px 20px;
    .right-title {
      font-size: 14px;
      color: #666;
      letter-spacing: 0;
      font-weight: 700;
      display: flex;
      justify-content: space-between;
      span {
        margin-left: 20px;
        font-size: 12px;
        font-weight: normal;
      }
      .right-border {
        border: 1px solid #E8ECEE;
        border-radius: 5px;
        padding: 5px 8px;
        font-weight: normal;
        font-size: 12px;
      }
    }
    .item-content {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 30px;
      .one-item {
        width: calc(100% - 10px);
        margin-right: 8px;
        padding: 17px 12px;
        border-radius: 4px;
        border: 1px solid hsla(0,0%,40%,.1);
        background: rgba(0,0,0,.02);
        position: relative;
        .top {
          font-size: 24px;
          color: #333;
        }
        .bottom {
          font-size: 12px;
          padding-top: 15px;
          color: #666;
          font-weight: normal;
        }
        .icon {
          position: absolute;
          top: 30px;
          right: 20px;
          color: #E7E9ED;
          i {
            font-size: 36px;
          }
        }
      }
    }
  }

</style>
